import { Translate } from '@chipinside/translate'
import { Box, IconButton, styled, Tooltip } from '@mui/material'

import { Icon } from '#/components/Icon'

/**
 * Botão para deletar uma entrada do grupo
 * Posicionado absolutamente no lado direito da entrada
 */
export function FormbuilderDeleteRow({ canRemove, index, onRemove }: any) {
  const handleClick = () => onRemove(index)

  return (
    canRemove && (
      <StyledDeleteButtonContainer>
        <Tooltip title={Translate({ messageKey: 'remove_row' })}>
          <IconButton size="small" aria-label="delete" color="error" onClick={handleClick}>
            <Icon name="trash" size={20} />
          </IconButton>
        </Tooltip>
      </StyledDeleteButtonContainer>
    )
  )
}

export const StyledDeleteButtonContainer = styled(Box)({
  position: 'absolute',
  right: '-5px',
  top: '50%',
  transform: 'translateY(-50%)',
  zIndex: 1,
})
